export default __webpack_public_path__ + "assets/images/ad7ae11b6e9f85e0bc7c596dd7832cbb.png";